import axios, { AxiosResponse } from "axios";
import { ID, Response } from "../../../../../../_metronic/helpers";
import { UserData, UserSearchResponse } from "./_models";
import { useMutation, useQuery } from "react-query";
import { UserSetSearchData } from "../../../core/_models";

const GET_ALL_USERS_URL = `/api/admin/users/`;

const USERS = `/api/users/`;

const API_URL = process.env.REACT_APP_API_URL;

const USER_URL = `${API_URL}/user`;

const ACTIVATE_USER = `${API_URL}/management/admin/activate`;

const DEACTIVATE_USER = `${API_URL}/management/admin/deactivate`;

const ACTIVATE_AUTH_USER = `${API_URL}/management/admin/activate/auth`;

const SEARCH_USER_URL = `${API_URL}/management/admin/`;

const CREATE_AGENT = `${API_URL}/management/admin/agent/create_agent`;

export const useAllUsers = () => {
  return useMutation("all-users", async (reqData: any) => {
    const { data } = await axios.get(
      `${GET_ALL_USERS_URL}?limit=${reqData.itemsValue}&offset=${
        reqData.currentItemsValue
      }${
        reqData.dataName === "tgName"
          ? `&tg.username=${reqData.data}`
          : reqData.dataName === "tgId"
          ? `&tg.id=${reqData.data}`
          : reqData.dataName === "uuid"
          ? `&uuid=${reqData.data}`
          : ""
      }`
    );
    return data.users;
  });
};

export const useGetOtherUserAvatar = () => {
  return useMutation<any, any, any>("other-user-avatar", async (uuid) => {
    const { data } = await axios.get(`${USERS}${uuid}/avatar/`);
    return data.avatar;
  });
};

export const useSearchUserName = () => {
  return useMutation<UserSearchResponse, any, UserSetSearchData>(
    "search-user",
    async (user: UserSetSearchData) => {
      const { data: response } = await axios.get(
        `${USERS}?${
          user.dataName === "tgName"
            ? `tg.username=${user.data}`
            : user.dataName === "tgId"
            ? `tg.id=${user.data}`
            : `uuid=${user.data}`
        }`
      );
      return response;
    }
  );
};

export const useSearchUser = (options: any) => {
  return useQuery(
    "search-user",
    async () => {
      const { data } = await axios.get(`${SEARCH_USER_URL}?data=${options}`);
      return data;
    },
    {
      refetchOnWindowFocus: false,
      ...options,
    }
  );
};

export const useGetSearchUser = () => {
  return useMutation<UserData, any, string | undefined>(
    "get-search-user",
    async (options) => {
      const { data } = await axios.get(`${SEARCH_USER_URL}?data=${options}`);
      return data;
    }
  );
};

export const useActivateUser = () => {
  return useMutation<UserData | any>({
    mutationFn: (body) => {
      return axios.put(`${ACTIVATE_USER}?uid=${body}`);
    },
  });
};

export const useActivateAuthUser = () => {
  return useMutation<UserData | any>({
    mutationFn: (body) => {
      return axios.put(`${ACTIVATE_AUTH_USER}?uid=${body}`);
    },
  });
};

export const useDeactivateUser = () => {
  return useMutation<UserData | any>({
    mutationFn: (body) => {
      return axios.put(`${DEACTIVATE_USER}?uid=${body}`);
    },
  });
};

export const useCreateAgent = () => {
  return useMutation<any>({
    mutationFn: (body) => {
      return axios.post(`${CREATE_AGENT}?data=${body}`);
    },
  });
};

const getUserById = (id: ID): Promise<UserData | undefined> => {
  return axios
    .get(`${USER_URL}/${id}`)
    .then((response: AxiosResponse<Response<UserData>>) => response.data)
    .then((response: Response<UserData>) => response.data);
};

const createUser = (user: UserData): Promise<UserData | undefined> => {
  return axios
    .put(USER_URL, user)
    .then((response: AxiosResponse<Response<UserData>>) => response.data)
    .then((response: Response<UserData>) => response.data);
};

const deleteUser = (userId: ID): Promise<void> => {
  return axios.delete(`${USER_URL}/${userId}`).then(() => {});
};

const deleteSelectedUsers = (userIds: Array<ID>): Promise<void> => {
  const requests = userIds.map((id) => axios.delete(`${USER_URL}/${id}`));
  return axios.all(requests).then(() => {});
};

export { deleteUser, deleteSelectedUsers, getUserById, createUser };
